import React, { Component } from 'react'
import createBarChart from '../../utils/barChart'

export default class Chart extends Component {
  componentDidMount() {
    this.updateBarChart(this.props.data)
  }

  componentDidUpdate(prevProps) {
    if (prevProps.data !== this.props.data) {
      this.updateBarChart(this.props.data)
    }
  }

  updateBarChart(data = []) {
    const { xAxis, yAxis } = this.props
    createBarChart(data, xAxis, yAxis)
  }

  render() {
    return (
      <canvas id="barChart" height="400" width="600">
        你的浏览器不支持HTML5 canvas
      </canvas>
    )
  }
}
